<template>
    <div id="post-video-player" v-if="content">
        <div class="col-lg-12 col-sm-12">
            <!--<img v-if="hidePlayIcon" width="70" height="70" id="play-icon-img" src="../assets/appIcons/Icon/Play.png" alt="">-->
            <div class="player-container">
                <vue3-video-player @play="hidePlayIconRun" @pause="hidePlayIconRun" :src="$store.state.base_urls.postsUploads+content.file_name"/>
            </div>
            <div class="explain" v-if="content.file_title">
                {{content.file_title}}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PostVideoPlayer",
        data() {
            return {
                hidePlayIcon:true,
            }
        },
        props:['content'],
        methods:{
            hidePlayIconRun:function () {
                this.hidePlayIcon=!this.hidePlayIcon;
            },
        }
    }
</script>

<style lang="scss" scoped>
    .explain{
        margin-top: 10px;
    }
    #post-video-player{
        div{
            padding: 0;
        }
    }
    #play-icon-img{
        position: absolute;
        top: 0%;
        bottom: 0%;
        left: 0;
        right: 0;
        margin: auto;
        z-index: 5;
        cursor: pointer!important;
    }
</style>